module.exports = __webpack_public_path__ + "img/DataEase-color.606a75ba.png";